import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";

import { fonts } from "../../../styles/variables";

export const WineCharacteristicsContainer = styled.div``;

export const WineCharacteristicsTitle = styled.div`
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  font-size: 11px;
  line-height: 10px;
  letter-spacing: 1.1px;
  margin-bottom: 24px;
`;

export const WineCharacteristics = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const CharacteristicWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 16px 32px 16px;
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  height: 40px;
  width: 40px;
`;

export const CharacteristicImage = styled.img<{ isPlaceholderImage: boolean }>`
  height: ${(props) => (props.isPlaceholderImage ? "27" : "32")}px;
  width: ${(props) => (props.isPlaceholderImage ? "22" : "32")}px;
`;

export const CharacteristicName = styled.div`
  font-family: ${fonts.fontBauMedium};
  font-size: 11px;
  line-height: 14px;
  width: 73px;
  text-align: center;
  text-transform: uppercase;

  ${breakpoints.smDown} {
    font-size: 9px;
    line-height: 12px;
  }
`;
